// extracted by mini-css-extract-plugin
export default {"a":"HkBrA7KyeEDEBHWui4Du","b":"s2GAykswWOYwpNkxunuA"};